<template lang="pug">
figure.customer-item
  a.customer-thumbnail(:href='item.link')
    img(:src='item.image_url')

  figcaption.customer-caption
    h4.customer-title
      a(:href='item.link') {{ item.title }}
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
}
</script>


